import { Card } from "antd";
import { FC } from "react";
import {
  Bar,
  BarChart,
  LabelList,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { useLocale } from "src/locales";
import { addComma } from "src/utils/StringUtil";

interface Props {
  data: any[];
  loading: boolean;
}

const MainAdGraph: FC<Props> = ({ data, loading }) => {
  const { formatMessage } = useLocale();

  return (
    <Card
      loading={loading}
      style={{
        borderRadius: "8px",
        marginInline: "6px",
        marginBottom: "10px",
        paddingTop: "10px",
      }}
      bordered={false}
    >
      <ResponsiveContainer height={250}>
        <BarChart data={data} layout="vertical" margin={{ right: 50 }}>
          <XAxis type="number" />
          <YAxis dataKey="name" type="category" width={100} />
          <Tooltip
            content={({ active, payload }: any) => {
              if (active && payload?.length > 1) {
                const percent =
                  ((payload[1].value / payload[0].value) * 100).toFixed(2) +
                  "%";
                return <div className="customTooltip">시청률 {percent}</div>;
              }
              return null;
            }}
          />

          <Legend verticalAlign="bottom" height={36} />
          <Bar
            dataKey="playCount"
            fill="#8884d8"
            name={formatMessage({
              id: "menu.dashboard.statisticsGraph.playCount",
            })}
          >
            <LabelList
              dataKey="playCount"
              position="right"
              formatter={addComma}
            />
          </Bar>
          <Bar
            dataKey="viewCount"
            fill="#82ca9d"
            name={formatMessage({
              id: "menu.dashboard.statisticsGraph.viewCount",
            })}
          >
            <LabelList
              dataKey="viewCount"
              position="right"
              formatter={addComma}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
};

export default MainAdGraph;
